export const YoutubeIcon = () => {
    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="50" height="50" rx="5" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M38.8187 13.7495C40.3596 14.1617 41.5617 15.3683 41.9785 16.9093C43.0684 21.3055 42.9974 29.6172 42.0014 34.0821C41.5892 35.623 40.3825 36.8251 38.8416 37.2419C34.4911 38.318 15.0058 38.1852 10.9072 37.2419C9.36623 36.8297 8.16414 35.623 7.74741 34.0821C6.71934 29.8919 6.79032 21.0308 7.72451 16.9322C8.13666 15.3912 9.34333 14.1891 10.8843 13.7724C16.7001 12.5589 36.7488 12.9504 38.8187 13.7495ZM21.4171 20.1378L30.759 25.4957L21.4171 30.8536V20.1378Z"
                fill="black"
            />
        </svg>
    );
};
